import Work1 from "../../assets/native-jobs.png";
import Work2 from "../../assets/cryptoverse.png";
import Work3 from "../../assets/travel.png";



const Menu = [
	{
		id: 1,
		image: Work1,
		title: "وب‌سایت آهن پرس (فرانت‌اند)",
		category: ["Frontend", "React"],
		url: "#",
		repositoryUrl: "#"
	},
	{
		id: 2,
		image: Work2,
		title: "مدل هوش مصنوعی تشخیص گیاه",
		category: ["AI", "Machine Learning"],
		url: "#",
		repositoryUrl: "#"
	},
	{
		id: 3,
		image: Work3,
		title: "مدل پردازش سیگنال مغزی با هوش مصنوعی",
		category: ["AI", "Signal Processing"],
		url: "#",
		repositoryUrl: "#"
	},
	{
		id: 4,
		image: Work3,
		title: "برنامه خانه هوشمند (فرانت‌اند)",
		category: ["Frontend", "React"],
		url: "#",
		repositoryUrl: "#"
	}
];

export default Menu;
